<template>
  <v-container fluid v-if="started && anyPlayersHaveStatus">
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 lg4 xl4 v-for="guild in this.guilds" :key="guild.key">
          <v-card>
            <v-card-title>                
              <!-- <img :src="require('../assets/' + guild.imageName)" alt="" style="height: 64px; width: 64px;"> -->
              <h3>{{guild.name}}'s Guild</h3>
            </v-card-title>
            <v-layout row wrap justify-space-around>
              <v-flex xs12 class="ml-2" v-if="guild.playersWithPrimaryStatus().length > 0">
                <b>Eligible For Guild Position</b>
              </v-flex>
              <v-flex
                xs12
                class="ml-2"
                v-for="playerWithPrimaryStatus in guild.playersWithPrimaryStatus()"
                :key="playerWithPrimaryStatus.id"
              >
                <v-flex
                  xs12
                  class="ml-2"
                  :style="{color: playerWithPrimaryStatus.color}"
                ><b>{{playerWithPrimaryStatus.name}}</b> - {{playerWithPrimaryStatus.status}}</v-flex>
              </v-flex>
              <v-flex xs12 class="ml-2" v-if="guild.playersWithSecondaryStatus().length > 0">
                <b>Ineligible For Guild Position</b>
              </v-flex>
              <v-flex
                xs12
                class="ml-2"
                v-for="playerWithSecondaryStatus in guild.playersWithSecondaryStatus()"
                :key="playerWithSecondaryStatus.id"
              >
                <v-flex
                  class="ml-2"
                  :style="{color: playerWithSecondaryStatus.color}"
                ><b>{{playerWithSecondaryStatus.name}}</b> - {{playerWithSecondaryStatus.status}}</v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  computed: {
    guilds() {
      return this.$store.state.guilds;
    },
    started() {
      return this.$store.state.started;
    },
    anyPlayersHaveStatus() {
      return this.$store.state.anyPlayersHaveStatus();
    }
  }
};
</script>

<style>
</style>
